/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
var deskConvertVersionControlRe = /original|control|baseline/i;
var deskConvertVersionStorageKey = 'desk_convert_version';
var deskConvertVersionLastWritten = null;

function deskConvertClassifyVariation(variation) {
  var text = ((variation && variation.name) || '') + ' ' + ((variation && variation.key) || '');
  return deskConvertVersionControlRe.test(text) ? 'Control' : 'Variation';
}

function deskConvertVersionStored() {
  try {
    return JSON.parse(sessionStorage.getItem(deskConvertVersionStorageKey)) || [];
  } catch (error) {
    return [];
  }
}

function deskConvertVersionStore(parts) {
  try {
    sessionStorage.setItem(deskConvertVersionStorageKey, JSON.stringify(parts));
  } catch (error) {
    return;
  }
}

function deskConvertVersionLiveParts() {
  var data = window.convert && window.convert.currentData;
  var experiences = data && data.experiences;
  if (!experiences) return [];

  var parts = [];
  Object.keys(experiences).forEach(function (id) {
    var variation = experiences[id] && experiences[id].variation;
    if (!variation) return;
    if (variation.status && variation.status !== 'running') return;
    parts.push({ id: String(id), version: deskConvertClassifyVariation(variation) });
  });
  return parts;
}

function deskConvertVersionParts() {
  var merged = [];
  var index = {};

  deskConvertVersionStored()
    .concat(deskConvertVersionLiveParts())
    .forEach(function (part) {
      if (!part || !part.id || !part.version) return;
      if (index[part.id] === undefined) {
        index[part.id] = merged.length;
        merged.push({ id: part.id, version: part.version });
        return;
      }
      merged[index[part.id]].version = part.version;
    });

  return merged;
}

function deskConvertVersionCapture() {
  var parts = deskConvertVersionParts();
  if (parts.length) deskConvertVersionStore(parts);
  return parts;
}

function deskConvertVersion() {
  var parts = deskConvertVersionParts();
  if (!parts.length) return null;

  var mixed = parts.some(function (part) {
    return part.version !== parts[0].version;
  });
  if (!mixed) return parts[0].version;

  return parts
    .map(function (part) {
      return part.id + ':' + part.version;
    })
    .join(', ');
}

function deskConvertVersionId() {
  var parts = deskConvertVersionParts();
  if (!parts.length) return null;

  return parts
    .map(function (part) {
      return part.id;
    })
    .join(', ');
}

function deskSetConvertVersionAttribute(extra) {
  deskConvertVersionCapture();

  var attributes = {};
  var pending = false;

  if (extra) {
    Object.keys(extra).forEach(function (key) {
      attributes[key] = extra[key];
      pending = true;
    });
  }

  var version = deskConvertVersion();
  var versionId = deskConvertVersionId();
  var stamp = version ? version + '|' + versionId : null;
  var wroteVersion = false;

  if (stamp && stamp !== deskConvertVersionLastWritten) {
    attributes.Version = version;
    attributes.VersionId = versionId;
    deskConvertVersionLastWritten = stamp;
    pending = true;
    wroteVersion = true;
  }

  if (!pending) return Promise.resolve(version);

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  return fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('cart/update.js responded ' + response.status);
      return version;
    })
    .catch(function () {
      if (wroteVersion) deskConvertVersionLastWritten = null;
      return null;
    });
}

deskConvertVersionCapture();
document.addEventListener('DOMContentLoaded', deskConvertVersionCapture);
window.addEventListener('load', deskConvertVersionCapture);
window.addEventListener('pagehide', deskConvertVersionCapture);

window.deskConvertVersion = deskConvertVersion;
window.deskConvertVersionId = deskConvertVersionId;
window.deskSetConvertVersionAttribute = deskSetConvertVersionAttribute;
